<template lang="pug">
.ResetPasswordPage
  .container
    .title パスワードの再設定
    .form
      .email
        input(type="email" name="email" v-model="email" placeholder="メールアドレス")
    .resetPasswordButton(@click="handleResetPasswordButtonClick") パスワード再設定
    .backButton(@click="handleBackButtonClick") 戻る
  .bg
</template>

<script>
import firebase from 'firebase'
// import soundService from '@/services/SoundService'

export default {
  name: 'reset-password-page',
  components: {},
  data() {
    return {
      email: ''
    }
  },
  methods: {
    goToLogin() {
      this.$router.push('/signIn')
    },
    handleResetPasswordButtonClick() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          alert(`${this.email}へ確認メールが送信されました`)
        })
        .catch(error => {
          switch (error.code) {
            default:
              alert(`${this.email}へ確認メールが送信されました`)
              break
            // case 'auth/invalid-email':
            //   alert('メールアドレスに誤りがあります')
            //   break
            // case 'auth/user-not-found':
            //   alert('ユーザーデータが見つかりませんでした')
            //   break
            // default:
            //   alert('誤りがあります')
            //   break
          }
        })
    },
    handleBackButtonClick() {
      this.goToLogin()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.ResetPasswordPage {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.container {
  padding: 20px;
  width: 300px;
  background: #fff;
  text-align: center;
  border-radius: 10px;
}

.title {
  margin: 0 0 10px 0;
  font-size: 1.8rem;
  font-weight: bold;
}

.form input {
  margin: 0 0 10px 0;
  padding: 10px;
  width: 100%;
  font-size: 2rem;
}

.resetPasswordButton {
  @include button;
  margin: 0 0 10px 0;
  padding: 10px;
  border: 0;
  background: orange;
  text-align: center;
  border-radius: 5px;
}

.backButton {
  @include button;
  padding: 10px;
  background: #eee;
  text-align: center;
  border-radius: 5px;
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 300vw;
  height: 300vh;
  background: url(../assets/bg_wood.jpg) repeat;
  // https://www.flickr.com/photos/seier/4342331255/sizes/l/
  animation: infinitescroll 20s linear infinite;
  z-index: -1;
}

@keyframes infinitescroll {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-1024px, -768px, 0);
  }
}
</style>
